import { CL_COUNTRY } from "@/shared-models/consumer/Country";
import {
  CODocService,
  IMCDocService,
  MXDocService,
  PEDocService,
} from "@/apps/credit-line/services/multi-country/multi-country-doc.service";
import { IContractData } from "@/apps/credit-line/models/IContractData";

/*
 * @see IMCDocService
 * @see MXDocService
 * @see CODocService
 */
export class DocFactoryService {
  /**
   * Create an implementation of `IMCDocService` for the provided country.
   *
   * @param country - The target country enum from `CL_COUNTRY`.
   * @param docData - Contract data forwarded to the concrete service.
   * @returns An instance of a country-specific `IMCDocService<IContractData>`.
   * @throws {Error} When the provided country is not supported.
   */
  static create(
    country: CL_COUNTRY,
    docData: IContractData
  ): IMCDocService<IContractData> {
    switch (country) {
      case CL_COUNTRY.MX:
        return new MXDocService(docData);
      case CL_COUNTRY.CO:
        return new CODocService(docData);
      case CL_COUNTRY.PE:
        return new PEDocService(docData);
      default:
        throw new Error(`Unsupported country: ${country}`);
    }
  }
}
